var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blog-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23325",
    "data-name": "Path 23325",
    d: "M22,7.662l1-1V18H16v4.745L11.255,18H1V2H17.763l-1,1H2V17h9.668L15,20.331V17h7ZM23.657,2.47a.965.965,0,0,1,.03,1.385l-9.325,9.324-4.1,1.755a.371.371,0,0,1-.487-.487l1.755-4.1,9.31-9.309a.98.98,0,0,1,1.385,0Zm-10.1,9.965-1.28-1.28-.961,2.24ZM20.8,5.325,19.386,3.912l-6.469,6.47L14.331,11.8ZM22.665,2.88l-.8-.838a.42.42,0,0,0-.6-.006L20.093,3.2l1.414,1.415,1.152-1.152a.42.42,0,0,0,.006-.587Z",
    fill: "#642d92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23326",
    "data-name": "Path 23326",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSvgrepoCom);
export default __webpack_public_path__ + "static/media/blog-svgrepo-com.dc64dfe92828fa381472d04b061a992b.svg";
export { ForwardRef as ReactComponent };